import { useRef, useState, type FC } from "react";
import { DeepDiveCopy } from "@tennr/frontend/components/DeepDiveCopy/DeepDiveCopy";
import { DeepDiveListItem } from "@tennr/frontend/components/DeepDiveListItem/DeepDiveListItem";
import "./DeepDiveSection.css";
import { LottieAnimation } from "@tennr/frontend/components/LottieAnimation";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type DeepDiveSectionProps = {
  // define any props if needed, currently empty
};

export const DeepDiveSection: FC<DeepDiveSectionProps> = (props) => {
  // track the deep dive items wrapper viewport progress
  const deepDiveItems = useRef<HTMLDivElement>(null!);
  const [activeId, setActiveId] = useState("classify");
  const [imageClass, setImageClass] = useState("");
  const swapImage = function (id: any) {
    setImageClass("transitioning");
    setTimeout(() => {
      setActiveId(id);
    }, 50);
    setTimeout(() => {
      setImageClass("");
    }, 200);
  };
  return (
    <section className="deep-dive section-y" style={{ backgroundImage: `url(${ props?.backgroundImage})`}}>
      <DeepDiveCopy button={props?.button ? true : false} heading={props?.heading ?? {}}/>
      <div className="deep-dive-items" ref={deepDiveItems}>
        <div className="deep-dive-list">
          {props.items.map(({ title, body, id }) => {
            return (
              <DeepDiveListItem
                key={id}
                title={title}
                body={body}
                id={id}
                active={activeId === id}
                setActive={() => swapImage(id)}
                lottie={true}
              />
            );
          })}
        </div>
        {props?.images && 
        <div className="deep-dive-image-container">
          <div
            className={`deep-dive-image ${imageClass != "" ? imageClass : ""}`}
            style={{ backgroundImage: `url(/svg/deep-dive-list-item-${activeId}.svg)` }}
          ></div>
        </div>
        }
        {props?.lottie &&
          <div className="deep-dive-image-container" style={{ marginTop: '-100px', marginBottom: '-100px'}}>
            <LottieAnimation
              src={`/lottie/deep-dive-list-item-${activeId}.lottie`}
              className={`deep-dive-image ${imageClass != "" ? imageClass : ""}`}
            />
          </div>
        }
      </div>
    </section>
  );
};
